import type { CSSProperties } from 'react';
import type { DiscoverySource } from '../data/discovery';
import { SourceMark } from './SourceMark';

export interface ProviderArtworkProps {
  source: DiscoverySource;
  size?: number;
  className?: string;
}

/** Public provider art: a generated mark for anonymous sources and official
 *  local logo assets for credited data brands. */
export const ProviderArtwork = ({ source, size = 40, className }: ProviderArtworkProps) => {
  const extra = `provider-artwork${className ? ` ${className}` : ''}`;
  if (source.kind !== 'brand') return <SourceMark id={source.id} size={size} className={extra} />;

  // Brand logos are letterboxed inside a padded tile. The inset must be derived
  // from `size` here - a percentage padding would resolve against the containing
  // block's width, not the element's own box, which swells the tile and
  // collapses the logo to nothing in narrow cells.
  const style: CSSProperties = {
    width: size,
    height: size,
    borderRadius: Math.round(size * 0.24),
    objectFit: 'contain',
    padding: Math.round(size * 0.12),
  };
  return (
    <img
      src={`/provider-artwork/brands/${source.artworkKey}.png`}
      alt=""
      width={size}
      height={size}
      className={`${extra} shrink-0 bg-surface-2`}
      style={style}
    />
  );
};
